import PageCommon from "./PageCommon.js";
import Pqp from "../3x1010/Pqp.js";
import Globals from "../Globals.js";

export default class PageCompare extends PageCommon {
	constructor() {
		super();
	}
	init( $data ) {
		super.init( $data );
    Pqp.trace("Page Compare - Hello world"); 
    //console.log($data)
    this.showPreloader(false);
		// dispaccio un evento globale
		this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);
	}

	get isHomepage() {
		return true;
	}
}


